export const css = {
    root: '_369qgIpG',
    title: 'KHRE2mgz',
    leading: 'U2VKeWDY',
    close: '_1J1Bi03l',
    skel: '_3AH5tdmO',
    ' _key': 'explore-view/micro-view'
};
export default css;
